import { compose, setDisplayName, withProps } from 'react-recompose';
import { reduxForm } from 'redux-form/immutable.js';

import withReduxConnect from '~/views/enhancers/withReduxConnect.js';
import withReduxDataLoading from '~/views/enhancers/withReduxDataLoading.js';

import { fetchOrganization, patchOrganization } from '~/state/ducks/organizations/operations.js';
import { getInitialFormData, getOrgID } from '~/state/ducks/organizations/selectors.js';

import OrganizationForm from './OrganizationForm.js';


export default compose(
    setDisplayName('OrganizationsEditContainer'),
    withReduxConnect({
        mapStateToProps: state => ({
            initialValues: getInitialFormData(state),
            linkToView: `../${getOrgID(state)}`,
        }),
    }),
    withReduxDataLoading({
        name: 'fetchOrganization',
        operation: ({ match: { params: { id } } }) => fetchOrganization(id),
    }),
    reduxForm({
        form: 'organizations-edit',
        onSubmit: patchOrganization,
        enableReinitialize: true,
    }),
    withProps({
        header: 'Edit',
    }),
)(OrganizationForm);
